import { ResumeSellPerDay } from '../../../domain/models/ResumeSellPerDay';
import { Sell } from '../../../domain/models/Sell';
import { Balance } from '../../../domain/models/Balance';

export interface BalanceStateInterface {
    resumeSellPerDay: ResumeSellPerDay;
    historic: Sell[];
    balance:Balance;
}
export class BalanceState implements BalanceStateInterface {

    balance:Balance;
    resumeSellPerDay: ResumeSellPerDay;
    historic: Sell[];

    constructor({
        balance = new Balance({}),
        resumeSellPerDay = new ResumeSellPerDay({}),
        historic = []
    }: BalanceStateInterface) {
        this.balance = balance
        this.resumeSellPerDay = resumeSellPerDay;
        this.historic = historic
    }
}